import React from "react";
import "../../css_files/Reports/ETQGraphDetails.css";
import CloseForm from "../Master/CloseForm";

function ETQGraphDetails({ details, headings, setShowDetails }) {
  return (
    <section className="graph-details-all">
      <section className="table" style={{ width: "70%" }}>
        <section>
          <div>
            <aside
              style={{
                gridTemplateColumns: `repeat(${headings?.length}, 1fr)`,
              }}
            >
              {headings.map((x) => (
                <blockquote style={{ width: "15rem" }}>{x}</blockquote>
              ))}
            </aside>
          </div>
          <div>
            {details.length > 0 ? (
              details.map((x) => (
                <aside
                  style={{
                    gridTemplateColumns: `repeat(${headings?.length}, 1fr)`,
                  }}
                >
                  {x.map((y) => (
                    <blockquote style={{ width: "15rem" }}>{y}</blockquote>
                  ))}
                </aside>
              ))
            ) : (
              <aside
                style={{
                  gridTemplateColumns: `repeat(${headings?.length}, 1fr)`,
                }}
              >
                <blockquote style={{ gridColumn: `span ${headings?.length}` }}>
                  <center>No Records Found</center>
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
      <CloseForm close={setShowDetails} />
    </section>
  );
}

export default ETQGraphDetails;
